import React, { FC, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import BurgerIcon from '../icons/Burger';
import CrossIcon from '../icons/Cross';
import NavDrawer from './NavDrawer';

const PhoneNavBar = styled.div`
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1),
    0px 1px 2px rgba(16, 24, 40, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 4rem;
  padding: 1rem;
  user-select: none;

  svg:last-child {
    stroke: var(--gray-500);
  }
  @media (min-width: 900px) {
    display: none;
  }
`;

const DrawerContainer = styled.div`
  display: flex;
  height: 100%;
  @media (min-width: 900px) {
    height: 100vh;
  }
`;

const DrawerClose = styled.div`
  height: 100%;
  background: var(--gray-700);
  width: 20%;
  opacity: 0.6;
  stroke: white;
  stroke-opacity: 1;
  display: flex;
  align-items: start;
  padding-top: 1.5rem;
  justify-content: center;

  @media (min-width: 900px) {
    display: none;
  }
`;

const DrawerContent = styled.div<{ isCollapsed: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
  border-right: 1px solid var(--gray-200);
  /* Ajout de la transition pour la fluidité */
  transition: width 0.3s ease; 
  /* Largeur dynamique : 80px si réduit, 280px sinon */
  width: ${({ isCollapsed }) => (isCollapsed ? '80px' : '280px')}; 
  overflow: hidden;

  @media (max-width: 900px) {
    border-right: none;
    width: 100%;
  }
`;

/* Logo du ministère : placé après le bloc compte, hors de la liste qui défile,
   et non compressible pour rester visible quelle que soit la hauteur d'écran. */
const MINISTRY_LOGO_SRC = '/logo-ministere-jeunesse.svg';

const MinistryLogo = styled.div<{ isCollapsed: boolean }>`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  margin-top: 1rem;

  img {
    display: block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: ${({ isCollapsed }) => (isCollapsed ? '56px' : '110px')};
  }
`;

const NavigationLayout: FC = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false); // État pour la réduction
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [setOpen, location]);

  return (
    <>
      <PhoneNavBar>
        <Link to="/">
          <img src="/logo.png" alt="Logo" height="24" style={{ marginRight: '.3rem' }} />
        </Link>
        <div onClick={() => setOpen(true)}>
          <BurgerIcon />
        </div>
      </PhoneNavBar>

      <NavDrawer open={open} close={() => setOpen(false)}>
        <DrawerContainer>
          {/* On passe l'état isCollapsed au styled-component */}
<DrawerContent isCollapsed={isCollapsed}>
  
  {/* 1. BOUTON DE RÉDUCTION (La flèche) */}
  <div style={{ 
    display: 'flex', 
    justifyContent: isCollapsed ? 'center' : 'flex-end', 
    marginBottom: '1rem' 
  }}>
    <button 
      onClick={() => setIsCollapsed(!isCollapsed)}
      style={{ 
        cursor: 'pointer', 
        background: 'none', 
        border: 'none', 
        fontSize: '1.2rem',
        padding: '5px'
      }}
      title={isCollapsed ? "Agrandir" : "Réduire"}
    >
      {isCollapsed ? '→' : '←'}
    </button>
  </div>

  {/* 2. LE LOGO (Sans le texte Mentorat) */}
  <div style={{ 
    marginBottom: '2rem', 
    display: 'flex', 
    justifyContent: isCollapsed ? 'center' : 'flex-start' 
  }}>
    <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
      <img
        src="/logo_institut_mentorat.png"
        alt="Logo"
        height="32"
        style={{ display: 'block' }}
      />
    </Link>
  </div>

  {/* La suite du code (Propagation des enfants) */}
  {React.Children.map(children, child => 
    React.isValidElement(child) ? React.cloneElement(child, { isCollapsed } as any) : child
  )}

  {/* 3. LOGO DU MINISTÈRE (toujours visible, en bas du panneau) */}
  <MinistryLogo isCollapsed={isCollapsed}>
    <img
      src={MINISTRY_LOGO_SRC}
      alt="Ministère de la Jeunesse, de l'Éducation populaire et de la Vie associative"
    />
  </MinistryLogo>
</DrawerContent>
          
          <DrawerClose>
            <div onClick={() => setOpen(false)}>
              <CrossIcon />
            </div>
          </DrawerClose>
        </DrawerContainer>
      </NavDrawer>
    </>
  );
};

export default NavigationLayout;
